import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DynamicTableWidgetDetailsM } from '../../models/dynamic-table/dynamic-table-widget-details.model';
import { AppMainService } from 'src/app/app-main.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DynamicTableWidgetService } from '../../services/dynamic-table/dynamic-table-widget.service';

@Component({
  selector: 'app-sublist-details-popup',
  templateUrl: './sublist-details-popup.component.html',
  styleUrl: './sublist-details-popup.component.scss'
})
export class SublistDetailsPopupComponent implements OnChanges {
 @Input() tabList: DynamicTableWidgetDetailsM[] = [];
    @Input() isLeftTableHide: boolean = false;
    activeTabIndex: number = 0;
    activeSubtabIndex: number = 0;


    constructor(
        private appMainService: AppMainService,
        private confirmationService: ConfirmationService,
        private dynamicTableWidgetService: DynamicTableWidgetService,
        private messageService: MessageService
    ){

    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['tabList']?.currentValue){
            this.tabList = changes['tabList']?.currentValue;
        }
    }

    onTabChange($event: any){

    }

    selectSubTab(index: number){
        this.activeSubtabIndex = index;
    }

    deleteSublist(sublistDetails: DynamicTableWidgetDetailsM) {
        this.confirmationService.confirm({
            message: 'Do you want to remove this Tab?',
            header: 'Remove Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.dynamicTableWidgetService.deleteWidget(sublistDetails.widgetId).subscribe({
                    next: (response)=>{
                        this.tabList = this.tabList.filter(t=> t.widgetId!==sublistDetails.widgetId);
                        this.activeTabIndex = 0;
                        this.activeSubtabIndex = 0;
                        this.appMainService.hideAllSpinner();
                        this.messageService.add({ severity: 'success', summary: 'Tab Removed', detail: 'Tab removed successfully!' });
                    },
                    error: (error)=>{
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while saving data...' });
                    }
                })
            },
            reject: () => {
            }
        });
    }
}
